import React, { FC } from 'react';
import { AllieCard, AllieText } from '../../../components';
import { ProductionOrderStyled, POProgressBar } from './ProductionOrder.styles';

interface ProductionOrderTvProps {
  title: string;
  progress: number;
  currentValue: number;
  targetValue: number;
  unit: string;
}

export const ProductionOrderTv: FC<ProductionOrderTvProps> = ({
  title,
  progress,
  currentValue,
  targetValue,
  unit,
}) => {
  const progressPercentage = Math.min(Math.round((currentValue / targetValue) * 100), 100);

  return (
    <ProductionOrderStyled>
      <AllieCard>
        <div style={{ padding: '24px' }}>
          <AllieText type="h4" weight={600}>
            {title}
          </AllieText>
        </div>
        <div style={{ padding: '0 24px 24px' }}>
          <POProgressBar isTv>
            <div
              style={{
                background: '#12B76A',
                width: `${progressPercentage}%`,
                height: '100%',
                borderRadius: '33px',
                transition: 'width 0.3s ease-in-out',
              }}
            />
          </POProgressBar>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              marginTop: '8px',
            }}
          >
            <AllieText type="body2" weight={400}>
              {`${currentValue}${unit}`}
            </AllieText>
            <AllieText type="body2" weight={400}>
              {`${targetValue}${unit}`}
            </AllieText>
          </div>
        </div>
      </AllieCard>
    </ProductionOrderStyled>
  );
};
